import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  isDataLoading: {},
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.IS_DATA_LOADING:
      // if (__DEV__)console.log(`isDataLoading  = ${action.key} == ${action.isLoading}`);
      return {
        ...state,
        isDataLoading: { ...state.isDataLoading, [action.key]: action.isLoading },
      };
    default:
      return state;
  }
};
